<template>
  <base-modal
    ref="modal"
    size="sm"
    centered
    hide-header
    hide-footer
    no-close
  >
    <div class="text-center pt-2">
      <div class="w-[52px] h-[52px] rounded-[20px] bg-[#f0eef5] flex items-center justify-center mx-auto mb-3.5">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#7c5bea" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/></svg>
      </div>
      <h5 class="text-base font-bold text-ink mb-1.5 -tracking-[0.01em]">Update available</h5>
      <p class="text-[13px] text-[#645B66] leading-relaxed mb-4">A new version is available. Reload to get the latest updates.</p>
      <button @click="reload" class="w-full bg-ink text-white text-sm font-medium py-2.5 rounded-full border-none cursor-pointer transition-opacity duration-150 hover:opacity-85">Reload</button>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal'

export default {
  components: { BaseModal },
  data () {
    return {
      currentVersion: null,
      timer: null,
      dismissed: false
    }
  },
  methods: {
    async checkVersion () {
      if (this.dismissed) return
      try {
        var response = await fetch('/version.json?t=' + Date.now())
        if (!response.ok) return
        var data = await response.json()
        if (!this.currentVersion) {
          this.currentVersion = data.version
          return
        }
        if (data.version !== this.currentVersion) {
          this.$refs.modal.show()
          this.stopPolling()
        }
      } catch (e) {
        // silently ignore fetch errors
      }
    },
    reload () {
      window.location.reload()
    },
    startPolling () {
      this.timer = setInterval(this.checkVersion, 60000)
    },
    stopPolling () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
  mounted () {
    if (process.env.NODE_ENV === 'production') {
      this.checkVersion()
      this.startPolling()
    }
  },
  beforeDestroy () {
    this.stopPolling()
  }
}
</script>
